import { render, staticRenderFns } from "./IRCaseMaintenanceNew.vue?vue&type=template&id=135b37c4"
import script from "./IRCaseMaintenanceNew.vue?vue&type=script&lang=js"
export * from "./IRCaseMaintenanceNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports